import AdvancedController from "./advanced-controller"
import { isDescendant } from "./utils";
import { fadeIn, fadeOut } from './animation-fade'
import { Breakpoints } from "./breakpoints";

const NAV_MAIN_MODE_CLICK = 0;
const NAV_MAIN_MODE_HOVER = 1;

export default class NavMainSubMenuController extends AdvancedController {

    static targets = [
        // the "real" anchor link of the menu
        'anchor',
        // the submenu ul
        'subMenu'
    ];

    static values = {
        // is this submenu visible
        isVisbible: Boolean,
        // the depth of this submenu
        depth: Number,
        blockHover: {
            default: false,
            type: Boolean
        }
    }

    connect() {
        super.connect();
        // outside click close
        if (Number(navMainSettings.mode) === NAV_MAIN_MODE_CLICK) {
            window.addEventListener('click', (e) => {
                if (this.isVisibleValue && !this.element.contains(e.target) && e.target.tagName !== 'A') {
                    this.isVisibleValue = false;
                    this._handleVisibility();
                }
            })
        }

        this.breakpoints = new Breakpoints();
    }

    initialize() {
        // stub
        this.element.classList.add(this._isPageLink() ? '-page-link' : '-no-page-link');
    }

    // Click-Mode (0 = NAV_MAIN_MODE_CLICK) -> More Click
    onMoreClick(e) {
        e.preventDefault();
        if (Number(navMainSettings.mode) === NAV_MAIN_MODE_CLICK || this.breakpoints.breakpointDown('md')) {
            this._toggle();
            this._handleVisibility();
        }
    }

    // Click-Mode (0 = NAV_MAIN_MODE_CLICK) -> Menu Item Click
    onMenuItemClick(e) {
        if (!this._isPageLink()) {
            if (this._isOnPageLink(e)) {
                // on page link with on-page-anchor is clicked, e.g. #section-123
                this.getController('header').messageCloseNav();
            } else {
                // custom link with only # in URL will toggle
                e.preventDefault();
                if (Number(navMainSettings.mode) === NAV_MAIN_MODE_CLICK) {
                    this._toggle();
                    this._handleVisibility();
                }
            }
        } else {
            // normal links to other pages -> do nothing
        }
    }

    // Hover-Mode (1 = NAV_MAIN_MODE_HOVER) -> Mouse Enter
    onMouseEnter(e) {
        if (!this.blockHoverValue && Number(navMainSettings.mode) === NAV_MAIN_MODE_HOVER && this.breakpoints.breakpointUp('md')) {
            e.preventDefault();

            this._closeSubmenus();
            this._closeSiblings();

            this.isVisibleValue = true;
            this._handleVisibility();
        }
    }

    // Hover-Mode (1 = NAV_MAIN_MODE_HOVER) -> Mouse Leave
    onMouseLeave(e) {
        if (Number(navMainSettings.mode) === NAV_MAIN_MODE_HOVER && this.breakpoints.breakpointUp('md')) {
            if (e.toElement === null || typeof e.toElement === 'undefined' || !isDescendant(this.element, e.toElement)) {
                e.preventDefault();
                this.isVisibleValue = false;
                this._handleVisibility();
            }
        }
    }

    _toggle() {
        this.isVisibleValue = !this.isVisibleValue
    }

    _handleVisibility() {
        if (this.isVisibleValue) {
            document.body.classList.add('-nav-open')
            this.element.classList.add("-active")
            this._show();
        } else {
            this.element.classList.remove("-active")
            const actives = document.querySelectorAll('.menu-item.-active')
            if (actives.length === 0) {
                document.body.classList.remove('-nav-open')
            }
            this._hide();
        }
    }

    _show() {
        fadeIn(this.subMenuTarget)
        this._closeSiblings();
    }

    _hide() {
        fadeOut(this.subMenuTarget)
        this._closeSubmenus();
    }

    _isPageLink() {
        return !this.element.classList.contains('menu-item-type-custom') || this.anchorTarget.href === "#"
    }

    _isOnPageLink(e) {
        const linkHref = e.target.getAttribute('href');
        return e.target.tagName === 'A' && linkHref.indexOf("#") === 0 && linkHref.length > 1
    }

    _closeSubmenus() {
        const otherControllers = this.getSubControllers('nav-main-sub-menu')
        for (const otherController of otherControllers) {
            otherController.messageClose();
        }
    }

    _closeSiblings() {
        const siblings = this.getSiblingControllers('nav-main-sub-menu')
        for (const sibling of siblings) {
            sibling.messageClose();
        }
    }

    messageClose() {
        this.isVisibleValue = false;
        this._handleVisibility();
    }

    // header-controller messages us when in progress to extend, thus
    // the hover shall be temporarily disabled (200ms is the anim time)
    messageBlockHover() {
        this.blockHoverValue = true
        setTimeout(() => {
            this.blockHoverValue = false
        }, 200)
    }

}
